// Override Settings
var bcSfSearchSettings = {
    search: {
        suggestionMobileStyle: 'style2',
        //suggestionMode: 'test',
        suggestionPosition: 'right',
        //suggestionWidth: 'auto'
        suggestionStyle: 'style3'
    }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
  	if (jQ(searchBoxId).closest('.search_container').length > 0) {
      	this.setSuggestionWidth(searchBoxId, 400);
  	}
};
if (window.location.pathname.includes('/products/')) {
BCSfFilter.prototype.prepareSuggestionParams = function(searchTerm, eventType) {
    var params = {};
    params.shop = Shopify.shop;
    params.t = new Date().getTime();
    if (!this.getSettingValue('search.enableDefaultResult')) params.enable_default_result = false;
    var enableFuzzy = this.getSettingValue('search.enableFuzzy');
    if (enableFuzzy !== true ) params.fuzzy = enableFuzzy;
    if (this.getSettingValue('search.fullMinMatch')) params.full_min_match = true;
    if (this.getSettingValue('search.reduceMinMatch') !== false) {
      params.reduce_min_match = this.getSettingValue('search.reduceMinMatch');
    }
    if (this.getSettingValue('search.enablePlusCharacterSearch')) params.enable_plus_character_search = true;
    // Get product/variant available or not
    if (this.getSettingValue('search.productAvailable') == true) params.product_available = true;
    // Limit
    var blocks = this.getSettingValue('search.suggestionBlocks');
    var k;
    var blocksLength = blocks.length;
    for (k = 0; k < blocksLength; k++) {
        var id = blocks[k]['type'].slice(0, -1);
        params[id + '_limit'] = blocks[k]['number'];
    }
    params['dym_limit'] = this.getSettingValue('search.suggestionDymLimit');
    // Skip fields
    var skipFields = this.getSettingValue('search.skipFields');
    if (skipFields.length > 0) param.skipFields = skipFields;
    params.callback = 'BCSfSuggestionCallback';
    params.event_type = eventType;
    // Suggest types
    var suggestionTypes = eventType == 'suggest_dym' ? ['products'] : this.getSettingValue('search.suggestionTypes');
    params.suggest_types = suggestionTypes;
    // params = this.setThirdPartyAppParams(params);
    return params;
};
BCSfFilter.prototype.buildSuggestionProductPrice = function(data) {
    /* Multi-currency Shopify */
    var self = this;
    self.prepareSuggestionProductPriceData(data);
    
    // Check on sale
    var onSale = data.compare_at_price_min > data.price_min;
    // Format price
    var price = this.formatMoney(data.price_min * 100).replace("$", "₹"),
        compareAtPrice = this.formatMoney(data.compare_at_price_min * 100).replace("$", "₹");
    if (this.getSettingValue('search.removePriceDecimal')) {
        price = this.removeDecimal(price).replace("$", "₹");
        compareAtPrice = this.removeDecimal(compareAtPrice).replace("$", "₹");
    }
    console.log(123, price)
    // Build Price
    var result = '';
    if (this.getSettingValue('search.showSuggestionProductPrice')) {
        result += '<div class="' + this.class.searchSuggestion + '-product-price">';
        if (onSale && this.getSettingValue('search.showSuggestionProductSalePrice')) {
            result += '<s>' + compareAtPrice + '</s>  ';
            result += '<span class="bc-sf-product-sale-price">' + price + '</span>';
        } else {
            result += '<span class="bc-sf-product-regular-price">' + price + '</span>';
        }
        result += '</div>';
    }
    return result;
};
var bcsffilter = new BCSfFilter(); bcsffilter.initSearchBox();
}
